import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import ShowMoreText from "react-show-more-text";

import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
    ClassicEditor, Bold, Essentials, Italic, Mention, Paragraph, Undo, Heading, FontFamily, FontSize,
    FontColor, FontBackgroundColor, Strikethrough, Subscript, Superscript, Code,
    Link, ImageUpload, CodeBlock, TodoList, Indent,
    Alignment
} from 'ckeditor5';
import moment from 'moment-jalaali';
import DatePicker from 'react-datepicker2';
import Drp_Brand from '../ProductBrand/Drp_Brand';
import Drp_Group from '../ProductGroup/Drp_Group';
import Drp_ParentGroup from '../ProductGroup/Drp_Group';
import PN from "persian-number";
import { forEach } from 'rsuite/esm/internals/utils/ReactChildren';

const InsertDiscountIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const BrandRef = useRef();
    const GroupRef = useRef();
    const ParentGroupRef = useRef();
    const [Id, setId] = useState(localStorage.getItem("DiscountId"));
    const [Title, setTitle] = useState('');
    const [Comment, setComment] = useState('');
    const [DiscountType, setDiscountType] = useState('-1');
    const [BeginDate, setBeginDate] = useState(moment(new Date()));
    const [EndDate, setEndDate] = useState(moment(new Date()));
    const [IsActive, setIsActive] = useState(true);
    const [SearchList, setSearchList] = useState([]);
    const [SelectList, setSelectList] = useState([]);
    //***************************************************** */

    const [SearchTitle, setSearchTitle] = useState('');
    const [SearchGroupId, setSearchGroupId] = useState(-1);
    const [SearchParentGroupId, setSearchParentGroupId] = useState(-1);
    const [SearchBrandId, setSearchBrandId] = useState(-1);
    //************************************************** */
    const [SearchCustomerType, setSearchCustomerType] = useState(-1);
    const [SearchIsCoWorker, setSearchIsCoWorker] = useState(-1);
    const [SearchIsCustomer, setSearchIsCustomer] = useState(-1);
    const [SearchIsSupplier, setSearchIsSupplier] = useState(-1);
    const [SearchIsActive, setSearchIsActive] = useState(1);

    //#endregion

    const BeginDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setBeginDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const EndDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setEndDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    //#region Methods


    const Search = () => {
        if (DiscountType == 2) {
            trackPromise(
                fetch(General.ApiRoute() + '/Product/SearchForDiscount', {
                    method: 'Get',
                    headers: {
                        'ApiKey': General.APIKey(),
                        'BrandId': SearchBrandId,
                        'DiscountId': Id,
                        'ProductGroupId': SearchGroupId,
                        'ProductGroupParentId': SearchParentGroupId,
                        'Title': SearchTitle,
                        'WebIsActive': SearchIsActive,
                        'IsActive': SearchIsActive
                    },
                    credentials: 'include'
                })
                    .then(res => res.json())
                    .then(result => {
                        var tmp = []
                        for (var i = 0; i < result.length; i++) {
                            if ([...SelectList].findIndex(x => x.ProductId == result[i].id) == -1)
                                tmp.push({
                                    Row: i + 1,
                                    Id: result[i].id,
                                    LastPrice: result[i].lastPrice,
                                    WebIsActive: result[i].webIsActive,
                                    IsActive: result[i].isActive,
                                    Product: result[i].title,
                                    ProductGroupParent: result[i].parentTitle,
                                    ProductGroup: result[i].groupTitle,
                                    ProductBrand: result[i].brandTitle,
                                    IsDeleted: 0

                                })
                        }
                        setSearchList(tmp)
                    })
            )

        }
        else if (DiscountType == 1) {
            trackPromise(
                fetch(General.ApiRoute() + '/User/SearchForDiscount', {
                    method: 'Get',
                    headers: {
                        'ApiKey': General.APIKey(),
                        'DiscountId': Id,
                        'Search': SearchTitle,
                        'CustomerType': SearchCustomerType,
                        'IsCoWorker': SearchIsCoWorker,
                        'IsCustomer': SearchIsCustomer,
                        'IsSupplier': SearchIsSupplier,
                        'IsActive': SearchIsActive
                    },
                    credentials: 'include'
                })
                    .then(res => res.json())
                    .then(result => {
                        var tmp = []
                        for (var i = 0; i < result.length; i++) {

                            if ([...SelectList].findIndex(x => x.CustomerId == result[i].id) == -1)
                                tmp.push({
                                    Row: i + 1,
                                    Id: result[i].id,
                                    FirstName: result[i].firstName,
                                    LastName: result[i].lastName,
                                    CustomerType: result[i].customerType,
                                    Mobile: result[i].mobile,
                                    Tel: result[i].tel,
                                    IsCoWorker: result[i].isCoWorker,
                                    IsSupplier: result[i].isSupplier,
                                    IsCustomer: result[i].isCustomer,
                                    IsDeleted: 0

                                })
                        }
                        setSearchList(tmp)
                    })
            )
        }
        else {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب نوع بسته اجباری می باشد")), 'topCenter')

        }
    }

    const Reset = () => {
        setId(General.GuidEmpty());
        setTitle('');
        setComment('');
        setDiscountType('-1');
        setBeginDate(moment(new Date()));
        setEndDate(moment(new Date()));
        setIsActive(true);
        setSearchList([]);
        setSelectList([]);
        //***************************************************** */
        setSearchTitle('');
        setSearchGroupId(-1);
        setSearchParentGroupId(-1);
        setSearchBrandId(-1);
        //************************************************** */
        setSearchCustomerType(-1);
        setSearchIsCoWorker(-1);
        setSearchIsCustomer(-1);
        setSearchIsSupplier(-1);
        setSearchIsActive(1);
    }


    const AddSelectiveList = (Id) => {
        var temp = [...SearchList];
        var index = temp.findIndex(x => x.Id == Id);
        if (index != -1) {

            var Selecttemp = [...SelectList];

            if (DiscountType == 2) { // Product
                var selectindex = Selecttemp.findIndex(x => x.ProductId == Id);
                console.dir(selectindex)
                if (selectindex == -1) {
                    Selecttemp.push({
                        Row: Selecttemp.length + 1,
                        ProductId: temp[index].Id,
                        Id: General.GuidEmpty(),
                        LastPrice: temp[index].LastPrice,
                        WebIsActive: temp[index].WebIsActive,
                        IsActive: temp[index].IsActive,
                        Product: temp[index].Product,
                        ProductGroupParent: temp[index].ProductGroupParent,
                        ProductGroup: temp[index].ProductGroup,
                        ProductBrand: temp[index].ProductBrand,
                        className: '',
                        Discount: 0,
                        IsDeleted: 0,

                    })
                    setSelectList(Selecttemp)
                    temp.splice(index, 1);
                    setSearchList(temp);


                }
                else {
                    console.dir(Selecttemp[index].IsDeleted)
                    if (Selecttemp[index].IsDeleted == 1) {
                        Selecttemp[index].IsDeleted = 0;
                        Selecttemp[index].Discount = 0;
                        temp.splice(index, 1);
                        setSearchList(temp);

                    }
                    else
                        Selecttemp.forEach(element => {
                            if (element.ProductId != Id)
                                element.className = ""
                            else
                                element.className = "bg-success"

                        });
                    setSelectList(Selecttemp)

                }

            }
            else if (DiscountType == 1) {
                var selectindex = Selecttemp.findIndex(x => x.CustomerId == Id);
                if (selectindex == -1) {
                    Selecttemp.push({
                        Row: Selecttemp.length + 1,
                        CustomerId: temp[index].Id,
                        Id: General.GuidEmpty(),
                        FirstName: temp[index].FirstName,
                        LastName: temp[index].LastName,
                        CustomerType: temp[index].CustomerType,
                        Mobile: temp[index].Mobile,
                        Tel: temp[index].Tel,
                        IsCoWorker: temp[index].IsCoWorker,
                        IsSupplier: temp[index].IsSupplier,
                        IsCustomer: temp[index].IsCustomer,
                        className: "",
                        Discount: 0,
                        IsDeleted: 0,

                    })
                    setSelectList(Selecttemp)
                    temp.splice(index, 1);
                    setSearchList(temp);
                }
                else {
                    if (Selecttemp[index].IsDeleted == 1) {
                        Selecttemp[index].IsDeleted = 0;
                        Selecttemp[index].Discount = 0;
                        temp.splice(index, 1);
                        setSearchList(temp);


                    }
                    else
                        Selecttemp.forEach(element => {
                            if (element.CustomerId != Id)
                                element.className = ""
                            else
                                element.className = "bg-success"

                        });
                    setSelectList(Selecttemp)

                }

            }
            else {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب نوع بسته اجباری می باشد")), 'topCenter')

            }
        }
    }

    const AddAllItem = () => {


        var Selecttemp = [...SelectList];

        if (DiscountType == 2) { // Product
            [...SearchList].forEach(element => {
                var selectindex = Selecttemp.findIndex(x => x.ProductId == element.Id);
                if (selectindex == -1) {
                    Selecttemp.push({
                        Row: Selecttemp.length + 1,
                        ProductId: element.Id,
                        Id: General.GuidEmpty(),
                        LastPrice: element.LastPrice,
                        WebIsActive: element.WebIsActive,
                        IsActive: element.IsActive,
                        Product: element.Product,
                        ProductGroupParent: element.ProductGroupParent,
                        ProductGroup: element.ProductGroup,
                        ProductBrand: element.ProductBrand,
                        className: '',
                    })
                }
                else {

                    Selecttemp[selectindex].IsDeleted = 0;
                    Selecttemp[selectindex].Discount = 0;
                }


            });
            setSelectList(Selecttemp)
            setSearchList([]);

        }
        else if (DiscountType == 1) {
            [...SearchList].forEach(element => {

                var selectindex = Selecttemp.findIndex(x => x.CustomerId == element.Id);
                if (selectindex == -1) {
                    Selecttemp.push({
                        Row: Selecttemp.length + 1,
                        CustomerId: element.Id,
                        Id: General.GuidEmpty(),
                        FirstName: element.FirstName,
                        LastName: element.LastName,
                        CustomerType: element.CustomerType,
                        Mobile: element.Mobile,
                        Tel: element.Tel,
                        IsCoWorker: element.IsCoWorker,
                        IsSupplier: element.IsSupplier,
                        IsCustomer: element.IsCustomer,
                        IsDeleted: 0,
                        Discount: 0,

                    })

                }
                else {
                    Selecttemp[selectindex].IsDeleted = 0;
                    Selecttemp[selectindex].Discount = 0;

                }
            })
            setSelectList(Selecttemp)
            setSearchList([]);

        }
        else {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب نوع بسته اجباری می باشد")), 'topCenter')

        }

    }

    const RemoveAllItem = () => {


        var Sarechtemp = [...SearchList];
        var Selecttemp = [...SelectList];

        if (DiscountType == 2) { // Product
            [...SelectList].forEach(element => {
                var index = Sarechtemp.findIndex(x => x.Id == element.ProductId);
                if (index == -1) {
                    Sarechtemp.push({
                        Row: Sarechtemp.length + 1,
                        Id: element.ProductId,
                        LastPrice: element.LastPrice,
                        WebIsActive: element.WebIsActive,
                        IsActive: element.IsActive,
                        Product: element.Product,
                        ProductGroupParent: element.ProductGroupParent,
                        ProductGroup: element.ProductGroup,
                        ProductBrand: element.ProductBrand,
                        className: '',
                    })
                }
                if (element.Id != General.GuidEmpty()) {
                    element.IsDeleted = 1;
                }
                else {
                    Selecttemp = [...SelectList].map(x => x.ProductId != element.Id);

                }

            });
            setSearchList(Sarechtemp)
            setSelectList(Selecttemp);

        }
        else if (DiscountType == 1) {
            [...SelectList].forEach(element => {

                var index = Sarechtemp.findIndex(x => x.Id == element.CustomerId);
                if (index == -1) {
                    Sarechtemp.push({
                        Row: Sarechtemp.length + 1,
                        Id: element.CustomerId,
                        FirstName: element.FirstName,
                        LastName: element.LastName,
                        CustomerType: element.CustomerType,
                        Mobile: element.Mobile,
                        Tel: element.Tel,
                        IsCoWorker: element.IsCoWorker,
                        IsSupplier: element.IsSupplier,
                        IsCustomer: element.IsCustomer,

                    })

                }
                if (element.Id != General.GuidEmpty()) {
                    element.IsDeleted = 1;
                }
                else {
                    Selecttemp = [...SelectList].map(x => x.CustomerId != element.Id);

                }
            })
            setSearchList(Sarechtemp)
            setSelectList(Selecttemp);

        }
        else {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب نوع بسته اجباری می باشد")), 'topCenter')

        }

    }

    const RemoveSelectiveList = (Id) => {
        var Selecttemp = [...SelectList];
        var index = Selecttemp.findIndex(x => DiscountType == 2 ? x.ProductId == Id : x.CustomerId == Id);
        if (index != -1) {

            var temp = [...SearchList];
            var searchindex = temp.findIndex(x => x.Id == Id);

            if (DiscountType == 2) { // Product
                if (searchindex == -1) {
                    temp.push({
                        Row: temp.length + 1,
                        Id: Selecttemp[index].ProductId,
                        LastPrice: Selecttemp[index].LastPrice,
                        WebIsActive: Selecttemp[index].WebIsActive,
                        IsActive: Selecttemp[index].IsActive,
                        Product: Selecttemp[index].Product,
                        ProductGroupParent: Selecttemp[index].ProductGroupParent,
                        ProductGroup: Selecttemp[index].ProductGroup,
                        ProductBrand: Selecttemp[index].ProductBrand,
                        className: '',
                    })
                    setSearchList(temp)

                }
                if (Selecttemp[index].Id != General.GuidEmpty()) {
                    Selecttemp[index].IsDeleted = 1;
                }
                else {
                    Selecttemp.splice(index, 1);

                }

                setSelectList(Selecttemp)
            }
            else if (DiscountType == 1) {
                if (searchindex == -1) {
                    temp.push({
                        Row: temp.length + 1,
                        Id: Selecttemp[index].CustomerId,
                        FirstName: Selecttemp[index].FirstName,
                        LastName: Selecttemp[index].LastName,
                        CustomerType: Selecttemp[index].CustomerType,
                        Mobile: Selecttemp[index].Mobile,
                        Tel: Selecttemp[index].Tel,
                        IsCoWorker: Selecttemp[index].IsCoWorker,
                        IsSupplier: Selecttemp[index].IsSupplier,
                        IsCustomer: Selecttemp[index].IsCustomer,

                    })
                    setSearchList(Selecttemp)
                }
                if (Selecttemp[index].Id != General.GuidEmpty()) {
                    Selecttemp[index].IsDeleted = 1;
                }
                else {
                    Selecttemp.splice(index, 1);

                }
                setSelectList(Selecttemp)



            }

        }
    }

    const ChangeAllDiscount = (e) => {
        var temp = [...SelectList];

        temp.forEach(element => {
            element.Discount = e;
        });
        setSelectList(temp);

    }

    const ChangeDiscount = (Id, e) => {
        var temp = [...SelectList];
        var index = temp.findIndex(x => DiscountType == 2 ? x.ProductId == Id : x.CustomerId == Id);
        temp[index].Discount = e;
        setSelectList(temp);
    }

    const Save = () => {
        if (Title == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("عنوان اجباری می باشد")), 'topCenter')
            return;
        }

        if (DiscountType == "-1") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("نوع بسته اجباری می باشد")), 'topCenter')
            return;
        }
        if (SelectList.length == 0) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" لیست مربوطه را تکمیل کنید")), 'topCenter')
            return;
        }
        var RequestOptions = {
            data: {
                "Id": Id,
                "Title": Title,
                "IsActive": IsActive ? 1 : 0,
                "DiscountType": DiscountType,
                "Comment": Comment,
                "products": DiscountType == 2 ? SelectList : [],
                "Custommers": DiscountType == 1 ? SelectList : [],
                "BeginDate": moment(BeginDate.format()).format('jYYYY/jMM/jDD'),
                "EndDate": moment(EndDate.format()).format('jYYYY/jMM/jDD'),

            },
            url: General.ApiRoute() + "/Discount/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                        if (Id != General.GuidEmpty()) {
                            localStorage.removeItem("DiscountId");
                            navigate("/Discount")
                        }
                        else
                            Reset();
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }

    const GetById = (id) => {
        setSearchList([])
        trackPromise(

            fetch(General.ApiRoute() + '/Discount/GetById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': Id,
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    setComment(result.comment);
                    setTitle(result.title);
                    setBeginDate(moment(result.beginDate, 'jYYYY/jMM/jDD'));
                    setEndDate(moment(result.endDate, 'jYYYY/jMM/jDD'));
                    setIsActive(result.isActive);
                    setDiscountType(result.discountType)
                    if (result.discountType == 2) {
                        for (var i = 0; i < result.products.length; i++) {
                            tmp.push({
                                Row: i + 1,
                                ProductId: result.products[i].productId,
                                Id: result.products[i].id,
                                LastPrice: result.products[i].lastPrice,
                                WebIsActive: result.products[i].webIsActive,
                                IsActive: result.products[i].isActive,
                                Product: result.products[i].product,
                                ProductGroupParent: result.products[i].productGroupParent,
                                ProductGroup: result.products[i].productGroup,
                                ProductBrand: result.products[i].productBrand,
                                Discount: result.products[i].discount,
                                IsDeleted: 0
                            })
                        }
                        setSelectList(tmp);
                    }
                    id(result.discountType == 1)
                    {
                        for (var i = 0; i < result.custommers.length; i++) {
                            tmp.push({
                                Row: i + 1,
                                CustomerId: result.custommers[i].customerId,
                                Id: result.custommers[i].id,
                                FirstName: result.custommers[i].firstName,
                                LastName: result.custommers[i].lastName,
                                CustomerType: result.custommers[i].customerType,
                                Mobile: result.custommers[i].mobile,
                                Tel: result.custommers[i].tel,
                                IsCoWorker: result.custommers[i].isCoWorker,
                                IsSupplier: result.custommers[i].isSupplier,
                                IsCustomer: result.custommers[i].isCustomer,
                                Discount: result.custommers[i].discount,
                                IsDeleted: 0
                            })
                        }
                        setSelectList(tmp);

                    }
                })
        )
    }



    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 17);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {

                        navigate("/AccessDenied");
                    }
                    else {
                        if (localStorage.getItem("DiscountId") != General.GuidEmpty()) {
                            GetById(localStorage.getItem("DiscountId"))
                        }
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    useEffect(() => {
        CheckPermission();
        document.title = "ثبت بسته تخفیفات";
    }, [])
    //#endregion







    return (

        <Layout title='ثبت بسته تخفیفات'>


            <div className="h-100 p-1">
                <rsuite.Panel className="bg-white h-10 ">
                    {/* <rsuite.Grid fluid> */}
                    <rsuite.Row>

                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                            <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={Save}>  ثبت</rsuite.Button>
                            <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={() => (localStorage.removeItem("DiscountId"), navigate("/Discount"))}>  بازگشت</rsuite.Button>

                        </rsuite.Col>
                    </rsuite.Row>
                    {/* </rsuite.Grid> */}
                    <hr />
                </rsuite.Panel>
                <div className="h-90 ">
                    <div className="h-100-y">


                        <rsuite.Row className="bg-white pe-2 ps-2">

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.Checkbox onChange={(e, checked) => setIsActive(checked)} checked={IsActive} value={IsActive} /> &nbsp;    فعال می باشد

                            </rsuite.Col>
                            <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                <label>عنوان</label>
                                <rsuite.Input value={Title} onChange={(e) => setTitle(e)} />
                            </rsuite.Col>

                            <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                <label> از تاریخ </label>
                                <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={BeginDate} onChange={BeginDate_Change} />


                            </rsuite.Col>
                            <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                <label> تا تاریخ </label>
                                <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={EndDate} onChange={EndDate_Change} />

                            </rsuite.Col>

                            <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                <label>نوع</label>
                                <select disabled={localStorage.getItem("DiscountId") != General.GuidEmpty() ? true : false} className="rs-input" onChange={(e) => (setDiscountType(e.target.value),
                                    setSelectList([]), setSearchList([]),
                                    e.target.value == 2 ? setTimeout(() => {
                                        ParentGroupRef.current.BindGroupByParentId(-1, 0);
                                    }, 500) : "")} value={DiscountType}>
                                    <option value="-1">انتخاب نمایید</option>
                                    <option value="1">تخفیف ویژه مشتریان  </option>
                                    <option value="2">تخفیف روی محصولات </option>
                                </select>
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-1'>
                                <CKEditor

                                    editor={ClassicEditor} data={Comment} onChange={(e, editor) => (setComment(editor.getData()), console.dir(editor.getData()), console.dir(e))}
                                    config={{
                                        toolbar: {
                                            items: ['undo', 'redo',
                                                '|', 'heading',
                                                '|', 'alignment', 'fontfamily', 'fontsize', 'fontColor', 'fontBackgroundColor',
                                                '|', 'bold', 'italic', 'strikethrough', 'subscript', 'superscript', 'code',
                                                '|', 'link',
                                                '|', 'todoList', 'indent'],
                                        },
                                        plugins: [
                                            Bold, Essentials, Italic, Mention, Paragraph,
                                            Undo, Heading, FontFamily, FontSize, Alignment,
                                            FontColor, FontBackgroundColor, Strikethrough,
                                            Subscript, Superscript, Code,
                                            Link, CodeBlock, TodoList, Indent
                                        ],

                                        licenseKey: '<YOUR_LICENSE_KEY>',
                                        language: {
                                            content: 'ar'
                                        },
                                        mention: {
                                            // Mention configuration
                                        },
                                        initialData: Comment,


                                    }}
                                />
                            </rsuite.Col>

                        </rsuite.Row>

                        <rsuite.Row className="bg-light">
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2 '>
                                <rsuite.Panel className="bg-white mt-2">

                                    <rsuite.Row className={DiscountType == 1 ? '' : 'hide'}>
                                        <rsuite.Col xxl={16} xl={16} lg={16} md={16} sm={12} xs={12}>
                                            <label>جستجو   </label>
                                            <rsuite.Input value={SearchTitle} onChange={(e) => setSearchTitle(e)} placeholder='نام، نام خانوادگی، شماره همراه، شماره ثابت' />
                                        </rsuite.Col>
                                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                                            <label> وضعیت فعال بودن   </label>
                                            <select className="rs-input" onChange={(e) => setSearchIsActive(e.target.value)} value={SearchIsActive}>
                                                <option value="-1">انتخاب نمایید</option>
                                                <option value="0">غیر فعال </option>
                                                <option value="1">فعال </option>
                                            </select>
                                        </rsuite.Col>
                                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                            <rsuite.Checkbox onChange={(e, checked) => setSearchIsCoWorker(checked)} checked={SearchIsCoWorker} value={SearchIsCoWorker} /> &nbsp; کاربر سیستم می باشد
                                        </rsuite.Col>
                                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                            <rsuite.Checkbox onChange={(e, checked) => setSearchIsCustomer(checked)} checked={SearchIsCustomer} value={SearchIsCustomer} /> &nbsp;  مشتری می باشد
                                        </rsuite.Col>
                                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className={SearchIsCustomer == 1 ? '' : 'hide'}>
                                            <rsuite.Checkbox onChange={(e, checked) => setSearchCustomerType(checked)} checked={SearchCustomerType} value={SearchCustomerType} /> &nbsp; همکار می باشد
                                        </rsuite.Col>

                                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                            <rsuite.Checkbox onChange={(e, checked) => setSearchIsSupplier(checked)} checked={SearchIsSupplier} value={SearchIsSupplier} /> &nbsp;  تامین کننده می باشد
                                        </rsuite.Col>

                                    </rsuite.Row>
                                    <rsuite.Row className={DiscountType == 2 ? '' : 'hide'}>
                                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                                            <label>عنوان   </label>
                                            <rsuite.Input value={SearchTitle} onChange={(e) => setSearchTitle(e)} />
                                        </rsuite.Col>
                                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                                            <label>گروه   </label>
                                            <Drp_ParentGroup className="rs-input" value={SearchParentGroupId} onChange={(value) => (setSearchParentGroupId(value), GroupRef.current.BindGroupByParentId(0, value))} ref={ParentGroupRef} />
                                        </rsuite.Col>
                                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                                            <label>زیر گروه   </label>
                                            <Drp_Group className="rs-input" value={SearchGroupId} onChange={(value) => setSearchGroupId(value)} ref={GroupRef} />
                                        </rsuite.Col>

                                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                                            <label> برند   </label>
                                            <Drp_Brand className="rs-input" value={SearchBrandId} onChange={(value) => setSearchBrandId(value)} ref={BrandRef} />
                                        </rsuite.Col>
                                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                                            <label> وضعیت فعال بودن   </label>
                                            <select className="rs-input" onChange={(e) => setSearchIsActive(e.target.value)} value={SearchIsActive}>
                                                <option value="-1">انتخاب نمایید</option>
                                                <option value="0">غیر فعال </option>
                                                <option value="1">فعال </option>


                                            </select>
                                        </rsuite.Col>
                                    </rsuite.Row>
                                    <rsuite.Row className={DiscountType != -1 ? '' : 'hide'}>
                                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='text-start'>
                                            <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={Search}>  جستجو</rsuite.Button>
                                        </rsuite.Col>
                                    </rsuite.Row>
                                </rsuite.Panel>
                            </rsuite.Col>
                            <rsuite.Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10} className='mt-2 '>
                                <rsuite.Panel className="bg-white mt-2 h-35vh  overflow-y">
                                    <table class="table table-hover ">
                                        <thead>
                                            <th>
                                                {DiscountType == 1 ?
                                                    "نام" : "عنوان"}
                                            </th>
                                            <th>
                                                {DiscountType == 1 ?
                                                    "نام خانوادگی" : "گروه"}
                                            </th>
                                            <th>
                                                {DiscountType == 1 ?
                                                    "شماره همراه " : "برند"}
                                            </th>
                                            <th>
                                                {DiscountType == 1 ?
                                                    "شماره ثابت " : "قیمت"}
                                            </th>
                                        </thead>
                                        <tbody>
                                            {SearchList.map(item => (
                                                <tr className='Cursor' onClick={() => AddSelectiveList(item.Id)}>
                                                    <td>
                                                        {DiscountType == 1 ?
                                                            item.FirstName : item.Product}
                                                    </td>
                                                    <td>
                                                        {DiscountType == 1 ?
                                                            item.LastName : item.ProductGroup}
                                                    </td>
                                                    <td>
                                                        {DiscountType == 1 ?
                                                            item.Mobile : item.ProductBrand}
                                                    </td>
                                                    <td>
                                                        {DiscountType == 1 ?
                                                            item.Tel : PN.sliceNumber(item.LastPrice)}
                                                    </td>
                                                </tr>

                                            ))}
                                        </tbody>
                                    </table>
                                </rsuite.Panel>

                            </rsuite.Col>
                            <rsuite.Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={2} className='mt-2 pt-5 p-1 bg-light '>
                                <br />
                                <br />
                                <br />
                                <br />
                                <rsuite.Button color="green" className='Font11' appearance="primary" block onClick={AddAllItem}>
                                    اضافه تمام آیتم ها
                                </rsuite.Button>
                                <rsuite.Button color="red" className='Font11' appearance="primary" block onClick={RemoveAllItem}>
                                    حذف تمام آیتم ها
                                </rsuite.Button>


                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='mt-2 '>
                                <rsuite.Panel className="bg-white mt-2 h-35vh overflow-y">
                                    <table class="table table-hover ">
                                        <thead>
                                            <th>
                                                {DiscountType == 1 ?
                                                    "نام" : "عنوان"}
                                            </th>
                                            <th>
                                                {DiscountType == 1 ?
                                                    "نام خانوادگی" : "گروه"}
                                            </th>
                                            <th>
                                                {DiscountType == 1 ?
                                                    "شماره همراه " : "برند"}
                                            </th>
                                            <th>
                                                {DiscountType == 1 ?
                                                    "شماره ثابت " : "قیمت"}
                                            </th>
                                            <th>
                                                <rsuite.Input onChange={ChangeAllDiscount} />
                                            </th>
                                        </thead>
                                        <tbody>
                                            {SelectList.map(item => (
                                                item.IsDeleted == 0 ?
                                                    <tr >
                                                        <td className={'Cursor ' + item.className} onClick={() => RemoveSelectiveList(DiscountType == 1 ?
                                                            item.CustomerId : item.ProductId)}>
                                                            {DiscountType == 1 ?
                                                                item.FirstName : item.Product}
                                                        </td>
                                                        <td className={'Cursor ' + item.className} onClick={() => RemoveSelectiveList(DiscountType == 1 ?
                                                            item.CustomerId : item.ProductId)}>
                                                            {DiscountType == 1 ?
                                                                item.LastName : item.ProductGroup}
                                                        </td>
                                                        <td className={'Cursor ' + item.className} onClick={() => RemoveSelectiveList(DiscountType == 1 ?
                                                            item.CustomerId : item.ProductId)}>
                                                            {DiscountType == 1 ?
                                                                item.Mobile : item.ProductBrand}
                                                        </td>
                                                        <td className={'Cursor ' + item.className} onClick={() => RemoveSelectiveList(DiscountType == 1 ?
                                                            item.CustomerId : item.ProductId)}>
                                                            {DiscountType == 1 ?
                                                                item.Tel : PN.sliceNumber(item.LastPrice)}
                                                        </td>
                                                        <td className={'Cursor ' + item.className}>
                                                            <rsuite.Input value={item.Discount} onChange={(e) => ChangeDiscount(DiscountType == 1 ?
                                                                item.CustomerId : item.ProductId, e)} />

                                                        </td>
                                                    </tr>
                                                    :
                                                    <></>

                                            ))}
                                        </tbody>
                                    </table>
                                </rsuite.Panel>
                            </rsuite.Col>



                        </rsuite.Row>


                    </div>
                </div>

            </div >



        </Layout >


    )
}

export default InsertDiscountIndex;